import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

const styles = theme => ({
  red: {
    color: theme.palette.red,
  },
  green: {
    color: theme.palette.green,
  },
  dialogPaper: {
    minWidth: '450px',
    minHeight: '85px',
  },
});

class ConfirmDialogComponent extends React.Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.cancel = this.cancel.bind(this);

    this.state = {
      isOpen: false,
    };
  }

  toggle() {
    this.setState({ isOpen: !this.state.isOpen });
  }

  cancel() {
    this.props.cancelCallback();
    this.toggle();
  }

  render() {
    const { classes } = this.props;
    return (
      <React.Fragment>
        <div
          role="presentation"
          onClick={this.toggle}
          onKeyPress={this.toggle}
        >
          {this.props.children}
        </div>

        <Dialog
          open={this.state.isOpen}
          onClose={this.toggle}
          aria-labelledby="simple-dialog-title"
          classes={{ paper: classes.dialogPaper }}
        >
          <DialogTitle>{this.props.title}</DialogTitle>
          <DialogContent>
            <DialogContentText>{this.props.bodyText}</DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.cancel} className={classes.red} autoFocus>Cancel</Button>
            <Button onClick={() => this.props.action()} className={classes.green} >Confirm</Button>
          </DialogActions>
        </Dialog>
      </React.Fragment>
    );
  }
}

ConfirmDialogComponent.propTypes = {
  title: PropTypes.string,
  bodyText: PropTypes.string,
  children: PropTypes.element.isRequired,
  action: PropTypes.func.isRequired,
  cancelCallback: PropTypes.func,
  /* eslint-disable react/forbid-prop-types */
  classes: PropTypes.object.isRequired,
  /* eslint-enable */
};

ConfirmDialogComponent.defaultProps = {
  title: 'Are you sure?',
  bodyText: 'Confirm your action.',
  cancelCallback: () => null,
};

export default withStyles(styles)(ConfirmDialogComponent);
